import { Box, Chip, ListItemButton, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

import {
  getActiveLayersChipColors,
  layersDrawerChevronButtonSx,
  layersDrawerRowActionsSx,
  layersDrawerRowContentSx,
  layersDrawerRowSx,
  layersDrawerRowTitleSx,
} from './layersDrawer.styles';

type LayerGroupItemProps = {
  titleKey: string;
  subtitleKey: string;
  totalLayers: number;
  activeLayers: number;
  onClick: () => void;
};

export const LayerGroupItem = (props: LayerGroupItemProps): JSX.Element => {
  const { titleKey, subtitleKey, totalLayers, activeLayers, onClick } = props;
  const { t } = useTranslation();

  const isActive = activeLayers > 0;
  const activeLayersChipSx = getActiveLayersChipColors(isActive);

  return (
    <ListItemButton
      onClick={onClick}
      aria-labelledby={titleKey}
      sx={layersDrawerRowSx}
    >
      <Box sx={layersDrawerRowContentSx}>
        <Typography
          component="span"
          id={titleKey}
          color="text.primary"
          sx={layersDrawerRowTitleSx}
        >
          {t(titleKey)}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {t(subtitleKey)}
        </Typography>
      </Box>
      <Box sx={layersDrawerRowActionsSx}>
        <Chip
          label={t('map.layers.activeItems', {
            count: activeLayers,
            total: totalLayers,
          })}
          variant="watchduty-count"
          component="span"
          data-testid="active-layers-count-chip"
          sx={activeLayersChipSx}
        />
        <Box aria-hidden sx={layersDrawerChevronButtonSx}>
          <ChevronRightIcon sx={{ color: 'text.primary' }} />
        </Box>
      </Box>
    </ListItemButton>
  );
};
